module.exports = __webpack_public_path__ + "img/15a)NH Hotel.jpg";